import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiCardActions = {
  styleOverrides: { root: { padding: '6px 12px 12px', gap: '6px' } },
} satisfies Components<Theme>['MuiCardActions'];
